import { Stack } from "@freightsimple/ui-core/ComponentLayout/Stack";
import { T } from "@freightsimple/ui-core/Typography/T";
import { Tooltip } from "@freightsimple/ui-core/Feedback/Tooltip";
import { lineItemsLimitExplanation } from "../Helpers/lineItemsLimitExplanation";

interface LineItemsTooManyLineItemsQuestionBubbleProps {
  maxLineItems: number;
}

export function LineItemsTooManyLineItemsQuestionBubble(
  props: LineItemsTooManyLineItemsQuestionBubbleProps,
) {
  return (
    <Tooltip
      variant="error"
      content={
        <Stack gap={2}>
          <T weight="bold">Too many line items</T>
          <T size="xs" color="secondary">
            {lineItemsLimitExplanation(props.maxLineItems)}
          </T>
        </Stack>
      }
    />
  );
}
